import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import tripReducer from './slices/tripSlice';
import factoryReducer from './slices/factorySlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    trips: tripReducer,
    factory: factoryReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 